import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';

import { EFilterType, EStrategy, IFilterParams, IFilterSelectOption } from '../filter.type';

@Component({
  selector: 'bixi-filter-advance-select',
  template: `
    <nz-form-item>
      <nz-form-label [nzSpan]="5">{{ option.title }}</nz-form-label>
      <nz-form-control [nzSpan]="19">
        <nz-select
          nzShowSearch
          nzAllowClear
          [nzMode]="mode"
          [(ngModel)]="filterParams[option.key]"
          [nzPlaceHolder]="option.placeholder"
          [nzDisabled]="option.disabled"
          [nzServerSearch]="option.serverSearch"
          (ngModelChange)="onModelChange($event)"
          (nzOnSearch)="onSearch($event)"
        >
          <nz-option *ngFor="let item of option.options | async" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  `,
  styles: [
    `
      nz-select {
        width: 100%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterAdvanceSelectComponent {
  @Input() option: Required<IFilterSelectOption>;
  @Input() filterParams: IFilterParams;
  @Output() valueChange = new EventEmitter<{ mode: EStrategy; type: EFilterType; value: NzSafeAny }>();

  get mode() {
    return this.option.multiple ? 'multiple' : 'default';
  }

  onModelChange(value: NzSafeAny) {
    this.option.onChange(value);
    this.valueChange.emit({ mode: EStrategy.normal, type: EFilterType.select, value });
  }

  onSearch(val: NzSafeAny) {
    this.option.onSearch(val);
  }
}
